// Imports
import React, { RefObject } from 'react';


// Define what the app container context looks like
type ContextDetails = {
	appContainerRef: RefObject<HTMLDivElement | null>;
};


// Create context
const AppContext = React.createContext<ContextDetails | undefined>(undefined);

export default AppContext;
